import { init as alert } from './modules/alert';
import { init as emailPopup } from './modules/email-popup';
import { init as header } from './modules/header';
import { init as hero } from './modules/hero';
import { init as spinbutton } from './modules/spinbutton';
import { init as pikadayDatepicker } from './modules/pikaday-datepickers';
import { init as carousel } from './modules/carousel';
import { init as horizontalMenu } from './modules/horizontal-nav';
import { init as faqs } from './modules/faqs';
import { init as contentBlocks } from './modules/content-block';
import { init as quickView } from './modules/quickview';
import { init as filters } from './modules/search/filters';
import { init as navbar } from './modules/navbar';
import { init as cookieNotice } from './modules/cookie-notice';
import { init as bannerCarousel } from './modules/banner-carousel';
import { lazy as lazyLoader } from './modules/lazy-loader';
import { init as shortlist } from './modules/shortlist';
import { init as propertyPage } from './modules/property-page';
import { init as tooltip } from './modules/tooltip';
import { init as modal } from './modules/modal';
import { init as fauxLink } from './modules/faux-block-link';
import { init as video } from './modules/video';
import { init as supercontrolBooking } from './modules/supercontrol-booking';

import './modules/search/index';
import './modules/property-card';
import './modules/instagram-feed';

lazyLoader();

function mount() {
	alert();
	header();
	hero();
	faqs();
	pikadayDatepicker();
	spinbutton();
	carousel();
	horizontalMenu();
	contentBlocks();
	quickView();
	filters();
	navbar();
	bannerCarousel();
	cookieNotice();
	shortlist();
	propertyPage();
	tooltip();
	modal();
	fauxLink();
	video();
	lazyLoader().update();
	emailPopup();
	supercontrolBooking();
}

mount();
